
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
@Component
export default class NotificationCard extends Vue {
  @Prop() link!: string;
  @Prop() type!: string;
  @Prop() date!: string;
  @Prop() content!: string;
  @Prop() meta!: string;
  @Prop() routePage!: string;

  id = '';

  get formattedDate() {
    return this.$dayjs(this.date).fromNow();
  }
}
